// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block-content-one-column_row{display:flex;justify-content:center}.block-content-one-column_col{max-width:95ch}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
